import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { logout as LogOut } from '../../actions/auth';
import { useAuth } from "../../contexts/AuthContext";


function Logout() {
  const { logout } = useAuth();
  const history = useHistory();

  useEffect(() => {
    async function logOut() {
      await LogOut();
      logout();
      history.push("/login");
    }
    logOut();
  }, []);

  return null;
}

export default Logout;
